module.exports = __webpack_public_path__ + "760398e75750e8ab2425121c7b151278.woff2";